import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5245">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5246">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5247">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5248">
            <ArrowLeft className="w-4 h-4" data-id="element-5249" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5250">NOIZA</div>
          <div className="w-20" data-id="element-5251" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5252">
        <div className="mb-12" data-id="element-5253">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5254">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5255" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5256">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5257">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5258">
          <section data-id="element-5259">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5260">
              <span className="text-[#006847]" data-id="element-5261">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5262">
              <p data-id="element-5263">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5264">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5265">
                <li data-id="element-5266">Haber leído íntegramente este documento</li>
                <li data-id="element-5267">Comprender su contenido en su totalidad</li>
                <li data-id="element-5268">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5269">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5270">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5271">
              <span className="text-[#006847]" data-id="element-5272">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5273">
              <p data-id="element-5274">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5275">
                <li data-id="element-5276">Software como servicio (SaaS)</li>
                <li data-id="element-5277">Marketplace digital gastronómico</li>
                <li data-id="element-5278">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5279">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5280">
                <li data-id="element-5281">Mostrar su menú digital</li>
                <li data-id="element-5282">Recibir pedidos de clientes</li>
                <li data-id="element-5283">Gestionar su operación interna</li>
                <li data-id="element-5284">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5285">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5286">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5287">
              <span className="text-[#006847]" data-id="element-5288">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5289">
              <p data-id="element-5290">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5291">
                <li data-id="element-5292">No es proveedor de alimentos</li>
                <li data-id="element-5293">No participa en la preparación de productos</li>
                <li data-id="element-5294">No manipula alimentos en ningún momento</li>
                <li data-id="element-5295">No realiza entregas ni logística</li>
                <li data-id="element-5296">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5297">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5298">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5299">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5300">
              <span className="text-[#006847]" data-id="element-5301">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5302">
              <p data-id="element-5303">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5304">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5305">
                <li data-id="element-5306">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5307">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5308">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5309">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5310">
                <li data-id="element-5311">Precios</li>
                <li data-id="element-5312">Menú</li>
                <li data-id="element-5313">Horarios</li>
                <li data-id="element-5314">Métodos de pago</li>
                <li data-id="element-5315">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5316">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5317">
              <span className="text-[#006847]" data-id="element-5318">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5319">
              <div data-id="element-5320">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5321">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5322">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5323">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5324">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5325">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5326">
                  <li data-id="element-5327">Calidad de los alimentos</li>
                  <li data-id="element-5328">Estado, frescura o preparación</li>
                  <li data-id="element-5329">Ingredientes utilizados</li>
                  <li data-id="element-5330">Contaminación cruzada</li>
                  <li data-id="element-5331">Problemas de higiene o salubridad</li>
                  <li data-id="element-5332">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5333">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5334">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5335">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5336">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5337">
                  <li data-id="element-5338">Retrasos en la entrega</li>
                  <li data-id="element-5339">Pérdida de pedidos</li>
                  <li data-id="element-5340">Entregas incompletas</li>
                  <li data-id="element-5341">Errores en dirección</li>
                  <li data-id="element-5342">Conducta de repartidores</li>
                  <li data-id="element-5343">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5344">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5345">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5346">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5347">
                  <li data-id="element-5348">Recepción de pagos</li>
                  <li data-id="element-5349">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5350">Manejo de efectivo</li>
                  <li data-id="element-5351">Confirmación de pagos</li>
                  <li data-id="element-5352">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5353">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5354">
                  <li data-id="element-5355">Pagos no recibidos</li>
                  <li data-id="element-5356">Comprobantes falsos</li>
                  <li data-id="element-5357">Errores en montos</li>
                  <li data-id="element-5358">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5359">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5360">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5361">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5362">
                  <li data-id="element-5363">Reclamos de clientes</li>
                  <li data-id="element-5364">Reembolsos</li>
                  <li data-id="element-5365">Cancelaciones</li>
                  <li data-id="element-5366">Disputas</li>
                  <li data-id="element-5367">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5368">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5369">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5370">
              <span className="text-[#006847]" data-id="element-5371">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5372">
              <p data-id="element-5373">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5374">
                <li data-id="element-5375">Responsable</li>
                <li data-id="element-5376">Legal</li>
                <li data-id="element-5377">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5378">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5379">
                <li data-id="element-5380">Publicar información falsa</li>
                <li data-id="element-5381">Manipular precios de forma engañosa</li>
                <li data-id="element-5382">Simular disponibilidad inexistente</li>
                <li data-id="element-5383">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5384">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5385">
              <span className="text-[#006847]" data-id="element-5386">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5387">
              <p data-id="element-5388">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5389">
                <li data-id="element-5390">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5391">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5392">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5393">
                <li data-id="element-5394">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5395">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5396">
                    <li data-id="element-5397">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5398">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5399">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5400">
              <span className="text-[#006847]" data-id="element-5401">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5402">
              <p data-id="element-5403">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5404">
                <li data-id="element-5405">Menú digital</li>
                <li data-id="element-5406">Gestión de pedidos</li>
                <li data-id="element-5407">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5408">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5409">
                  <p className="font-medium text-white mb-2" data-id="element-5410">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5411">
                    <li data-id="element-5412">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5413">
                  <p className="font-medium text-white mb-2" data-id="element-5414">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5415">
                    <li data-id="element-5416">Propiedad del software</li>
                    <li data-id="element-5417">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5418">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5419">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5420">
              <span className="text-[#006847]" data-id="element-5421">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5422">
              <p data-id="element-5423">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5424">
                <li data-id="element-5425">Disponibilidad continua</li>
                <li data-id="element-5426">Funcionamiento sin interrupciones</li>
                <li data-id="element-5427">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5428">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5429">
                <li data-id="element-5430">Fallas técnicas</li>
                <li data-id="element-5431">Actualizaciones</li>
                <li data-id="element-5432">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5433">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5434">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5435">
              <span className="text-[#006847]" data-id="element-5436">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5437">
              <p data-id="element-5438">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5439">
                <li data-id="element-5440">No está garantizada permanentemente</li>
                <li data-id="element-5441">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5442">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5443">
                <li data-id="element-5444">Destacar o no restaurantes</li>
                <li data-id="element-5445">Modificar posiciones</li>
                <li data-id="element-5446">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5447">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5448">
              <span className="text-[#006847]" data-id="element-5449">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5450">
              <p data-id="element-5451">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5452">
                <li data-id="element-5453">Cumplir con los pagos acordados</li>
                <li data-id="element-5454">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5455">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5456">
                <li data-id="element-5457">Suspender el servicio</li>
                <li data-id="element-5458">Limitar funcionalidades</li>
                <li data-id="element-5459">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5460">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5461">
              <span className="text-[#006847]" data-id="element-5462">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5463">
              <p data-id="element-5464">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5465">
                <li data-id="element-5466">Incumplimiento de términos</li>
                <li data-id="element-5467">Uso indebido</li>
                <li data-id="element-5468">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5469">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5470">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5471">
              <span className="text-[#006847]" data-id="element-5472">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5473">
              <p data-id="element-5474">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5475">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5476">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5477">
              <span className="text-[#006847]" data-id="element-5478">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5479">
              <p data-id="element-5480">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5481">
                <li data-id="element-5482">Pérdidas económicas</li>
                <li data-id="element-5483">Daños indirectos</li>
                <li data-id="element-5484">Lucro cesante</li>
                <li data-id="element-5485">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5486">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5487">
              <span className="text-[#006847]" data-id="element-5488">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5489">
              <p data-id="element-5490">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5491">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5492">
              <span className="text-[#006847]" data-id="element-5493">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5494">
              <p className="font-medium" data-id="element-5495">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5496">
                <li data-id="element-5497">Ha leído este documento completo</li>
                <li data-id="element-5498">Comprende su alcance</li>
                <li data-id="element-5499">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}